function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { isPlainObject as e } from "is-plain-object";
function t(e) {
  var t = function (e, t) {
    if ("object" != _typeof(e) || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (void 0 !== n) {
      var r = n.call(e, "string");
      if ("object" != _typeof(r)) return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }(e);
  return "symbol" == _typeof(t) ? t : t + "";
}
function n(e, n) {
  for (var r = 0; r < n.length; r++) {
    var i = n[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, t(i.key), i);
  }
}
function r(e, t, r) {
  return t && n(e.prototype, t), r && n(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function i() {
  return i = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, i.apply(this, arguments);
}
function o(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, u(e, t);
}
function u(e, t) {
  return u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, u(e, t);
}
function a(e, t) {
  if (null == e) return {};
  var n = {};
  for (var r in e) if (Object.prototype.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) >= 0) continue;
    n[r] = e[r];
  }
  return n;
}
var f = {
    silent: !1,
    logLevel: "warn"
  },
  l = ["validator"],
  c = Object.prototype,
  s = c.toString,
  v = c.hasOwnProperty,
  d = /^\s*function (\w+)/;
function p(e) {
  var t,
    n = null !== (t = null == e ? void 0 : e.type) && void 0 !== t ? t : e;
  if (n) {
    var r = n.toString().match(d);
    return r ? r[1] : "";
  }
  return "";
}
var y = e;
function h() {}
var b = h;
if ("production" !== process.env.NODE_ENV) {
  var g = "undefined" != typeof console;
  b = g ? function (e, t) {
    void 0 === t && (t = f.logLevel), !1 === f.silent && console[t]("[VueTypes warn]: " + e);
  } : h;
}
var O = function O(e, t) {
    return v.call(e, t);
  },
  m = Number.isInteger || function (e) {
    return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
  },
  j = Array.isArray || function (e) {
    return "[object Array]" === s.call(e);
  },
  _ = function _(e) {
    return "[object Function]" === s.call(e);
  },
  T = function T(e, t) {
    return y(e) && O(e, "_vueTypes_name") && (!t || e._vueTypes_name === t);
  },
  w = function w(e) {
    return y(e) && (O(e, "type") || ["_vueTypes_name", "validator", "default", "required"].some(function (t) {
      return O(e, t);
    }));
  };
function P(e, t) {
  return Object.defineProperty(e.bind(t), "__original", {
    value: e
  });
}
function k(e, t, n) {
  var r;
  void 0 === n && (n = !1);
  var i = !0,
    o = "";
  r = y(e) ? e : {
    type: e
  };
  var u = T(r) ? r._vueTypes_name + " - " : "";
  if (w(r) && null !== r.type) {
    if (void 0 === r.type || !0 === r.type) return i;
    if (!r.required && null == t) return i;
    j(r.type) ? (i = r.type.some(function (e) {
      return !0 === k(e, t, !0);
    }), o = r.type.map(function (e) {
      return p(e);
    }).join(" or ")) : i = "Array" === (o = p(r)) ? j(t) : "Object" === o ? y(t) : "String" === o || "Number" === o || "Boolean" === o || "Function" === o ? function (e) {
      if (null == e) return "";
      var t = e.constructor.toString().match(d);
      return t ? t[1].replace(/^Async/, "") : "";
    }(t) === o : t instanceof r.type;
  }
  if (!i) {
    var a = u + 'value "' + t + '" should be of type "' + o + '"';
    return !1 === n ? (b(a), !1) : a;
  }
  if (O(r, "validator") && _(r.validator)) {
    var f = b,
      l = [];
    if (b = function b(e) {
      l.push(e);
    }, i = r.validator(t), b = f, !i) {
      var c = (l.length > 1 ? "* " : "") + l.join("\n* ");
      return l.length = 0, !1 === n ? (b(c), i) : c;
    }
  }
  return i;
}
function x(e, t) {
  var n = Object.defineProperties(t, {
      _vueTypes_name: {
        value: e,
        writable: !0
      },
      isRequired: {
        get: function get() {
          return this.required = !0, this;
        }
      },
      def: {
        value: function value(e) {
          return void 0 === e ? this.type === Boolean || Array.isArray(this.type) && this.type.includes(Boolean) ? void (this["default"] = void 0) : (O(this, "default") && delete this["default"], this) : _(e) || !0 === k(this, e, !0) ? (this["default"] = j(e) ? function () {
            return [].concat(e);
          } : y(e) ? function () {
            return Object.assign({}, e);
          } : e, this) : (b(this._vueTypes_name + ' - invalid default value: "' + e + '"'), this);
        }
      }
    }),
    r = n.validator;
  return _(r) && (n.validator = P(r, n)), n;
}
function S(e, t) {
  var n = x(e, t);
  return Object.defineProperty(n, "validate", {
    value: function value(e) {
      return _(this.validator) && b(this._vueTypes_name + " - calling .validate() will overwrite the current custom validator function. Validator info:\n" + JSON.stringify(this)), this.validator = P(e, this), this;
    }
  });
}
function A(e, t, n) {
  var r,
    i,
    o = (r = t, i = {}, Object.getOwnPropertyNames(r).forEach(function (e) {
      i[e] = Object.getOwnPropertyDescriptor(r, e);
    }), Object.defineProperties({}, i));
  if (o._vueTypes_name = e, !y(n)) return o;
  var u,
    f,
    c = n.validator,
    s = a(n, l);
  if (_(c)) {
    var v = o.validator;
    v && (v = null !== (f = (u = v).__original) && void 0 !== f ? f : u), o.validator = P(v ? function (e) {
      return v.call(this, e) && c.call(this, e);
    } : c, o);
  }
  return Object.assign(o, s);
}
function E(e) {
  return e.replace(/^(?!\s*$)/gm, "  ");
}
var N = function N() {
    return S("any", {});
  },
  V = function V() {
    return S("function", {
      type: Function
    });
  },
  q = function q() {
    return S("boolean", {
      type: Boolean
    });
  },
  L = function L() {
    return S("string", {
      type: String
    });
  },
  B = function B() {
    return S("number", {
      type: Number
    });
  },
  D = function D() {
    return S("array", {
      type: Array
    });
  },
  F = function F() {
    return S("object", {
      type: Object
    });
  },
  Y = function Y() {
    return x("integer", {
      type: Number,
      validator: function validator(e) {
        var t = m(e);
        return !1 === t && b('integer - "' + e + '" is not an integer'), t;
      }
    });
  },
  I = function I() {
    return x("symbol", {
      validator: function validator(e) {
        var t = "symbol" == _typeof(e);
        return !1 === t && b('symbol - invalid value "' + e + '"'), t;
      }
    });
  },
  J = function J() {
    return Object.defineProperty({
      type: null,
      validator: function validator(e) {
        var t = null === e;
        return !1 === t && b("nullable - value should be null"), t;
      }
    }, "_vueTypes_name", {
      value: "nullable"
    });
  };
function M(e, t) {
  if (void 0 === t && (t = "custom validation failed"), "function" != typeof e) throw new TypeError("[VueTypes error]: You must provide a function as argument");
  return x(e.name || "<<anonymous function>>", {
    type: null,
    validator: function validator(n) {
      var r = e(n);
      return r || b(this._vueTypes_name + " - " + t), r;
    }
  });
}
function R(e) {
  if (!j(e)) throw new TypeError("[VueTypes error]: You must provide an array as argument.");
  var t = 'oneOf - value should be one of "' + e.map(function (e) {
      return "symbol" == _typeof(e) ? e.toString() : e;
    }).join('", "') + '".',
    n = {
      validator: function validator(n) {
        var r = -1 !== e.indexOf(n);
        return r || b(t), r;
      }
    };
  if (-1 === e.indexOf(null)) {
    var r = e.reduce(function (e, t) {
      if (null != t) {
        var n = t.constructor;
        -1 === e.indexOf(n) && e.push(n);
      }
      return e;
    }, []);
    r.length > 0 && (n.type = r);
  }
  return x("oneOf", n);
}
function U(e) {
  if (!j(e)) throw new TypeError("[VueTypes error]: You must provide an array as argument");
  for (var t = !1, n = !1, r = [], i = 0; i < e.length; i += 1) {
    var o = e[i];
    if (w(o)) {
      if (_(o.validator) && (t = !0), T(o, "oneOf") && o.type) {
        r = r.concat(o.type);
        continue;
      }
      if (T(o, "nullable")) {
        n = !0;
        continue;
      }
      if (!0 === o.type || !o.type) {
        b('oneOfType - invalid usage of "true" and "null" as types.');
        continue;
      }
      r = r.concat(o.type);
    } else r.push(o);
  }
  r = r.filter(function (e, t) {
    return r.indexOf(e) === t;
  });
  var u = !1 === n && r.length > 0 ? r : null;
  return x("oneOfType", t ? {
    type: u,
    validator: function validator(t) {
      var n = [],
        r = e.some(function (e) {
          var r = k(e, t, !0);
          return "string" == typeof r && n.push(r), !0 === r;
        });
      return r || b("oneOfType - provided value does not match any of the " + n.length + " passed-in validators:\n" + E(n.join("\n"))), r;
    }
  } : {
    type: u
  });
}
function $(e) {
  return x("arrayOf", {
    type: Array,
    validator: function validator(t) {
      var n = "",
        r = t.every(function (t) {
          return !0 === (n = k(e, t, !0));
        });
      return r || b("arrayOf - value validation error:\n" + E(n)), r;
    }
  });
}
function z(e) {
  return x("instanceOf", {
    type: e
  });
}
function C(e) {
  return x("objectOf", {
    type: Object,
    validator: function validator(t) {
      var n = "",
        r = Object.keys(t).every(function (r) {
          return !0 === (n = k(e, t[r], !0));
        });
      return r || b("objectOf - value validation error:\n" + E(n)), r;
    }
  });
}
function G(e) {
  var t = Object.keys(e),
    n = t.filter(function (t) {
      var n;
      return !(null === (n = e[t]) || void 0 === n || !n.required);
    }),
    r = x("shape", {
      type: Object,
      validator: function validator(r) {
        var i = this;
        if (!y(r)) return !1;
        var o = Object.keys(r);
        if (n.length > 0 && n.some(function (e) {
          return -1 === o.indexOf(e);
        })) {
          var u = n.filter(function (e) {
            return -1 === o.indexOf(e);
          });
          return b(1 === u.length ? 'shape - required property "' + u[0] + '" is not defined.' : 'shape - required properties "' + u.join('", "') + '" are not defined.'), !1;
        }
        return o.every(function (n) {
          if (-1 === t.indexOf(n)) return !0 === i._vueTypes_isLoose || (b('shape - shape definition does not include a "' + n + '" property. Allowed keys: "' + t.join('", "') + '".'), !1);
          var o = k(e[n], r[n], !0);
          return "string" == typeof o && b('shape - "' + n + '" property validation error:\n ' + E(o)), !0 === o;
        });
      }
    });
  return Object.defineProperty(r, "_vueTypes_isLoose", {
    writable: !0,
    value: !1
  }), Object.defineProperty(r, "loose", {
    get: function get() {
      return this._vueTypes_isLoose = !0, this;
    }
  }), r;
}
var H = ["name", "validate", "getter"],
  K = /*#__PURE__*/function (e) {
    return e = /*#__PURE__*/function () {
      function e() {}
      return e.extend = function (e) {
        var t = this;
        if (b("VueTypes.extend is deprecated. Use the ES6+ method instead. See https://dwightjack.github.io/vue-types/advanced/extending-vue-types.html#extending-namespaced-validators-in-es6 for details."), j(e)) return e.forEach(function (e) {
          return t.extend(e);
        }), this;
        var n = e.name,
          r = e.validate,
          i = void 0 !== r && r,
          o = e.getter,
          u = void 0 !== o && o,
          f = a(e, H);
        if (O(this, n)) throw new TypeError('[VueTypes error]: Type "' + n + '" already defined');
        var l,
          c = f.type;
        return T(c) ? (delete f.type, Object.defineProperty(this, n, u ? {
          get: function get() {
            return A(n, c, f);
          }
        } : {
          value: function value() {
            var e,
              t = A(n, c, f);
            return t.validator && (t.validator = (e = t.validator).bind.apply(e, [t].concat([].slice.call(arguments)))), t;
          }
        })) : (l = u ? {
          get: function get() {
            var e = Object.assign({}, f);
            return i ? S(n, e) : x(n, e);
          },
          enumerable: !0
        } : {
          value: function value() {
            var e,
              t,
              r = Object.assign({}, f);
            return e = i ? S(n, r) : x(n, r), r.validator && (e.validator = (t = r.validator).bind.apply(t, [e].concat([].slice.call(arguments)))), e;
          },
          enumerable: !0
        }, Object.defineProperty(this, n, l));
      }, r(e, null, [{
        key: "any",
        get: function get() {
          return N();
        }
      }, {
        key: "func",
        get: function get() {
          return V().def(this.defaults.func);
        }
      }, {
        key: "bool",
        get: function get() {
          return void 0 === this.defaults.bool ? q() : q().def(this.defaults.bool);
        }
      }, {
        key: "string",
        get: function get() {
          return L().def(this.defaults.string);
        }
      }, {
        key: "number",
        get: function get() {
          return B().def(this.defaults.number);
        }
      }, {
        key: "array",
        get: function get() {
          return D().def(this.defaults.array);
        }
      }, {
        key: "object",
        get: function get() {
          return F().def(this.defaults.object);
        }
      }, {
        key: "integer",
        get: function get() {
          return Y().def(this.defaults.integer);
        }
      }, {
        key: "symbol",
        get: function get() {
          return I();
        }
      }, {
        key: "nullable",
        get: function get() {
          return J();
        }
      }]);
    }(), e.defaults = {}, e.sensibleDefaults = void 0, e.config = f, e.custom = M, e.oneOf = R, e.instanceOf = z, e.oneOfType = U, e.arrayOf = $, e.objectOf = C, e.shape = G, e.utils = {
      validate: function validate(e, t) {
        return !0 === k(t, e, !0);
      },
      toType: function toType(e, t, n) {
        return void 0 === n && (n = !1), n ? S(e, t) : x(e, t);
      }
    }, e;
  }();
function Q(e) {
  var t;
  return void 0 === e && (e = {
    func: function func() {},
    bool: !0,
    string: "",
    number: 0,
    array: function array() {
      return [];
    },
    object: function object() {
      return {};
    },
    integer: 0
  }), t = /*#__PURE__*/function (t) {
    function n() {
      return t.apply(this, arguments) || this;
    }
    return o(n, t), r(n, null, [{
      key: "sensibleDefaults",
      get: function get() {
        return i({}, this.defaults);
      },
      set: function set(t) {
        this.defaults = !1 !== t ? i({}, !0 !== t ? t : e) : {};
      }
    }]);
  }(K), t.defaults = i({}, e), t;
}
var W = /*#__PURE__*/function (e) {
  function t() {
    return e.apply(this, arguments) || this;
  }
  return o(t, e), t;
}(Q());
export { N as any, D as array, $ as arrayOf, q as bool, f as config, Q as createTypes, M as custom, W as default, A as fromType, V as func, z as instanceOf, Y as integer, J as nullable, B as number, F as object, C as objectOf, R as oneOf, U as oneOfType, G as shape, L as string, I as symbol, x as toType, S as toValidableType, k as validateType };